export enum BaseComponentTypeEnum {
  TOC = 'TOC',
  ATTRIBUTE_LIST = 'ATTRIBUTE_LIST',
  DRAWING = 'DRAWING',
  LEGEND = 'LEGEND',
  PRINT = 'PRINT',
  BACKGROUND_LAYER_TOGGLE = 'BACKGROUND_LAYER_TOGGLE',
  FEATURE_INFO = 'FEATURE_INFO',
  COORDINATE_PICKER = 'COORDINATE_PICKER',
  MEASURE = 'MEASURE',
  MOUSE_COORDINATES = 'MOUSE_COORDINATES',
  SCALE_BAR = 'SCALE_BAR',
  SIMPLE_SEARCH = 'SIMPLE_SEARCH',
  ZOOM = 'ZOOM',
  FILTER = 'FILTER',
  GEOLOCATION = 'GEOLOCATION',
  STREETVIEW = 'STREETVIEW',
  EDIT = 'EDIT',
  SHARE_VIEWER = 'SHARE_VIEWER',
  COORDINATE_LINK_WINDOW = 'COORDINATE_LINK_WINDOW',
  TERRAIN_LAYER_TOGGLE = 'TERRAIN_LAYER_TOGGLE',
  HEADER = 'HEADER',
  INFO = 'INFO',
  TERRAIN_OPACITY = 'TERRAIN_OPACITY',
  MOBILE_MENUBAR_HOME = 'MOBILE_MENUBAR_HOME',
  TERRAIN_CONTROLS = 'TERRAIN_CONTROLS',
  PROFILE = 'PROFILE',
  SNAPPING = 'SNAPPING',
}
